export default "__VITE_ASSET__vXMyitOj__"